export default __webpack_public_path__ + "static/keyboard-5-seconds-79419f6911fe0711d7b1bf20397e392a.mp3";